import Vue from 'vue'
import VuePaginate from 'vue-paginate'

Vue.use(VuePaginate)



// WEBPACK FOOTER //
// ./client/plugins/vue-paginate.js